import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentGrantAccessHttpClient } from './tellent-grant-access.http';
import { TellentGrantAccessActions } from './tellent-grant-access.store';

@Injectable({ providedIn: 'root' })
export class TellentGrantAccessEffects {
  public effects = createEffectFactory(TellentGrantAccessActions, this.actions$);

  public getSignInList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentGrantAccessActions.fetchPaginatedCollection),
      mergeMap(({ payload }) =>
        this.tellentGrantAccessHttpClient.fetchSignInCOnsetList(payload.params).pipe(
          map(({ data, meta }) =>
            TellentGrantAccessActions.fetchPaginatedCollectionSuccess({
              payload: { data: { rows: data, meta }, scope: payload.scope },
            }),
          ),
          catchError(error =>
            of(TellentGrantAccessActions.fetchPaginatedCollectionFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public grantAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentGrantAccessActions.grantAccess),
      mergeMap(() =>
        this.tellentGrantAccessHttpClient.grantAccess().pipe(
          map(() => TellentGrantAccessActions.grantAccessSuccess()),
          catchError(error => of(TellentGrantAccessActions.grantAccessFail({ payload: error }))),
        ),
      ),
    ),
  );

  public revokeAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentGrantAccessActions.revokeAccess),
      mergeMap(() =>
        this.tellentGrantAccessHttpClient.revokeAccess().pipe(
          map(response => TellentGrantAccessActions.revokeAccessSuccess({ payload: response })),
          catchError(error => of(TellentGrantAccessActions.revokeAccessFail({ payload: error }))),
        ),
      ),
    ),
  );

  constructor(
    private tellentGrantAccessHttpClient: TellentGrantAccessHttpClient,
    private actions$: Actions,
  ) {}
}
